import * as React from "react";
import { Tooltip } from "antd";
import { connect } from "react-redux";
import LogInStoreForm from "./LogInStoreForm";
import { EditFilled } from "@ant-design/icons";
import ScanMe from "../assets/images/scanproduct.png";
import { url } from "inspector";
import { BUS_PARENT_SITE } from "../constants/StoreSetting";
import { checkIsWeb, postDataToApp } from "../appRedux/actions/MobAppFn";
import { PostAppTypes } from "../constants/MobAppConstants";
import { env } from '../env'

const { REACT_APP_BUS_FIRST_NAME } = env
const LogInStore = () => {
  return checkIsWeb().exist ? (
   
            <div className="signin-panel-store">
            
            <div className="signin-panel-features">
               
               <Tooltip placement="bottom" title="Coming Soon">

                  <div className="OmniChannel-slideshow div-flow">


                      <a href="" target="_blank" className="cus-mb-12 div-flow text-center">
                        <img src={ScanMe} />
                      </a>

                      
                      <a href="" target="_blank" className="primary-anchor div-flow text-white">
                      <h6 className="text-white">Omni channel retail by {REACT_APP_BUS_FIRST_NAME}</h6>
                      </a>
                      

                      
                        <a href="" target="_blank" className="primary-anchor text-white div-flow">
                          Robust inventory management capabilities designed to optimize your profits.
                        </a>
                    

                  </div>
                </Tooltip>
              </div>

              
                <LogInStoreForm />
              

            </div>
         
  )  : <></>;
};

export default connect()(LogInStore);
